import "./styles.scss";

import React from "react";

const Author = ({ avatar, first_name, last_name }) => {
  return (
    <div className="blog-post-author">
      {avatar && (
        <img
          src={avatar}
          alt=""
          className="blog-post-author__avatar img-fluid"
        />
      )}
      {first_name && (
        <div className="blog-post-author__name">
          {first_name}
          <br />
          {last_name}
        </div>
      )}
    </div>
  );
};

export default Author;
